export default "__VITE_ASSET__BYkPM7si__"